/* Quantum Waves presentation. Delegated controls survive Shopify section reloads. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (designMode) document.documentElement.classList.add('shopify-design-mode');
  var revealObserver = 'IntersectionObserver' in window && !reduced && !designMode
    ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); revealObserver.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -5% 0px' }) : null;
  var currentAudio;
  var audioByPlayer = new WeakMap();

  function updateHeader() {
    document.querySelectorAll('[data-header]').forEach(function (header) {
      header.dataset.scrolled = window.scrollY > 8 ? 'true' : 'false';
    });
  }
  window.addEventListener('scroll', updateHeader, { passive: true });

  function reveal(root) {
    root.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (!revealObserver) el.classList.add('is-in');
      else revealObserver.observe(el);
    });
    // Text stays opaque in CSS, including when observer events are unavailable.
  }

  function initAnnouncements(root) {
    root.querySelectorAll('[data-announce]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      var key = bar.getAttribute('data-announce-dismiss');
      try { if (!designMode && key && sessionStorage.getItem('announce:' + key) === 'closed') { bar.hidden = true; return; } } catch (_) {}
      var items = bar.querySelectorAll('[data-announce-item]');
      var track = bar.querySelector('[data-announce-track]');
      var pause = bar.querySelector('[data-announce-pause]');
      var i = 0, timer, paused = false;
      function stop() { clearInterval(timer); }
      function start() {
        stop();
        if (reduced || designMode || paused || items.length < 2 || bar.hidden) return;
        timer = setInterval(function () {
          if (!bar.isConnected) { stop(); return; }
          items[i].hidden = true; i = (i + 1) % items.length; items[i].hidden = false;
        }, (Number(track.dataset.interval) || 6) * 1000);
      }
      if (pause) {
        if (reduced || designMode) pause.hidden = true;
        pause.addEventListener('click', function () {
          paused = !paused; pause.setAttribute('aria-pressed', String(paused));
          if (paused) stop(); else start();
        });
      }
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', function (e) { if (!bar.contains(e.relatedTarget)) start(); });
      bar.__cleanup = stop;
      start();
    });
  }

  function init(root) {
    updateHeader();
    root.querySelectorAll('[data-compare]').forEach(function (el) {
      var range = el.querySelector('input[type="range"]');
      if (range) el.style.setProperty('--pos', range.value + '%');
    });
    reveal(root);
    initAnnouncements(root);
  }

  document.addEventListener('input', function (e) {
    if (!e.target.matches('.compare__range')) return;
    var compare = e.target.closest('[data-compare]');
    if (compare) compare.style.setProperty('--pos', e.target.value + '%');
  });

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-announce-close]');
    if (close) {
      var bar = close.closest('[data-announce]');
      if (bar) {
        var key = bar.getAttribute('data-announce-dismiss');
        try { if (key && !designMode) sessionStorage.setItem('announce:' + key, 'closed'); } catch (_) {}
        if (bar.__cleanup) bar.__cleanup();
        bar.hidden = true;
      }
    }
    var video = e.target.closest('[data-video]');
    if (video && /^[A-Za-z0-9_-]{6,20}$/.test(video.dataset.video)) {
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + video.dataset.video + '?autoplay=1&rel=0';
      frame.title = video.dataset.title || 'Video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.allowFullscreen = true;
      var wrap = document.createElement('div');
      wrap.className = video.className;
      wrap.dataset.playing = 'true';
      wrap.appendChild(frame); video.replaceWith(wrap); frame.focus();
    }
    var playerButton = e.target.closest('.player__btn');
    var player = playerButton && playerButton.closest('[data-player]');
    if (!player || !player.dataset.src) return;
    var audio = audioByPlayer.get(player);
    if (!audio) {
      audio = new Audio(player.dataset.src); audio.preload = 'none'; audioByPlayer.set(player, audio);
      audio.addEventListener('timeupdate', function () {
        var progress = player.querySelector('.player__prog');
        if (progress && audio.duration) progress.style.right = (100 - audio.currentTime / audio.duration * 100) + '%';
      });
      function stopped() { player.dataset.state = ''; playerButton.setAttribute('aria-pressed', 'false'); }
      audio.addEventListener('pause', stopped); audio.addEventListener('ended', stopped);
      audio.addEventListener('error', function () { stopped(); player.dataset.state = 'unavailable'; playerButton.disabled = true; });
    }
    if (!audio.paused) { audio.pause(); return; }
    if (currentAudio && currentAudio !== audio) currentAudio.pause();
    currentAudio = audio;
    audio.play().then(function () { player.dataset.state = 'playing'; playerButton.setAttribute('aria-pressed', 'true'); }).catch(function () { player.dataset.state = ''; });
  });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-announce]').forEach(function (bar) { if (bar.__cleanup) bar.__cleanup(); });
    e.target.querySelectorAll('[data-player]').forEach(function (player) { var audio = audioByPlayer.get(player); if (audio) audio.pause(); });
    if (revealObserver) e.target.querySelectorAll('[data-reveal]').forEach(function (el) { revealObserver.unobserve(el); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var question = e.target.closest('details[data-qa]');
    if (question) question.open = true;
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });
  // Preserve existing partner attribution, with no requests or payout claims.
  try {
    var key = 'qw-ref', incoming = new URLSearchParams(location.search).get('ref');
    if (incoming) {
      var clean = incoming.toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 40);
      if (clean) localStorage.setItem(key, JSON.stringify({ code: clean, exp: Date.now() + 30 * 864e5 }));
    }
    var held = JSON.parse(localStorage.getItem(key) || 'null');
    if (held && held.exp < Date.now()) localStorage.removeItem(key);
  } catch (_) {}
  init(document);
})();
